module.exports = __webpack_public_path__ + "img/title.6cc7afd2.png";